$(document).ready(function() {
  $(".maker-item .btn-readmore").on('click', function(){
    $(this).parents('.maker-description').toggleClass('expanded');
  });

  $('.makers-nav-item a').on('click', function(e) {
    e.preventDefault();
    var target = $(e.target);
    $('.makers-nav-item a').each(function() {
      $(this).removeClass('actived');
    });
    target.addClass('actived');
    
    var elementID = target.attr('href');
    var element = $(elementID);
    $('html, body').animate({
      scrollTop: element.offset().top - 150
    }, 500);
  });
});